function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18.925 5.613L10.5 10.294V20.67l8.194-4.196a.58.58 0 0 0 .306-.518V5.905a.603.603 0 0 0-.075-.292zm-.971-.605l-7.722-3.952a.507.507 0 0 0-.464 0L2.045 5.01 10 9.428l7.954-4.42zm-16.88.606A.603.603 0 0 0 1 5.905v10.05a.58.58 0 0 0 .306.518L9.5 20.666V10.294l-8.425-4.68zM9.313.166a1.507 1.507 0 0 1 1.376 0l8.462 4.33c.52.268.85.813.85 1.41v10.049a1.58 1.58 0 0 1-.85 1.408l-8.802 4.508a1.524 1.524 0 0 1-.01.005l-.167.084a.377.377 0 0 1-.342-.002L.85 17.363A1.58 1.58 0 0 1 0 15.954V5.905c0-.596.33-1.141.85-1.408L9.312.167z"
});

var SvgAr = function SvgAr(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ar.61591fb5.svg";
export { ForwardRef as ReactComponent };